import * as t from "io-ts";
const timeReservedIntervalT = t.tuple([t.string, t.string]);
const driverTimeReservedT = t.strict({
    driverId: t.string,
    revision: t.string,
    data: t.record(t.string, timeReservedIntervalT),
    total: t.array(timeReservedIntervalT),
});
const driversTimeReservedT = t.array(driverTimeReservedT);
const driverTimeReservedUpdatedEventT = t.intersection([
    driverTimeReservedT,
    t.strict({ timestamp: t.string }),
]);
export { timeReservedIntervalT, driverTimeReservedT, driversTimeReservedT, driverTimeReservedUpdatedEventT, };
//# sourceMappingURL=driver-time-reserved.js.map